// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1LA1l","addWidgetButton":"Header_addWidgetButton__2ioo_","dashboardTabs":"Header_dashboardTabs__2D7wC","active":"Header_active__1OVAi"};